exports.connect = {
	url: "https://api.lesjardinsdelamer.camp/"
}
